import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useDarkMode } from "../../contexts/ThemeContext";
import Card from "../ui/Card";
import {
  faList,
  faBox,
  faExclamationTriangle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";

// Counter cards component for DonateMaterials page
const CounterCards = ({ counters, isLoading = false, justUpdated = false }) => {
  const { t } = useTranslation();
  const { darkMode } = useDarkMode();

  const totalListings = counters?.listings ?? 0;
  const uniqueMaterials = counters?.materials ?? 0;
  const expiringSoon = counters?.expiringSoon ?? 0;
  const overdue = counters?.overdue ?? 0;

  // Define counter cards with color classes
  const counterCards = [
    {
      icon: faList,
      value: totalListings,
      title: t("Listings"),
      description: t("Total material listings"),
      colorClass: "counter-blue",
    },
    {
      icon: faBox,
      value: uniqueMaterials,
      title: t("Materials"),
      description: t("Unique material types"),
      colorClass: "counter-green",
    },
    {
      icon: faExclamationTriangle,
      value: expiringSoon,
      title: t("Expiring Soon"),
      description: t("Within 7 days"),
      colorClass: "counter-amber",
    },
    {
      icon: faTimesCircle,
      value: overdue,
      title: t("Overdue Listings"),
      description: t("Past pickup date"),
      colorClass: "counter-red",
    },
  ];

  return (
    <div className="counter-cards-container">
      {counterCards.map((card, index) => (
        <Card
          key={index}
          icon={card.icon}
          value={card.value}
          title={card.title}
          description={card.description}
          variant="counter"
          colorClass={card.colorClass}
          darkMode={darkMode}
          isLoading={isLoading}
          justUpdated={justUpdated}
        />
      ))}
    </div>
  );
};

CounterCards.propTypes = {
  counters: PropTypes.shape({
    listings: PropTypes.number,
    materials: PropTypes.number,
    expiringSoon: PropTypes.number,
    overdue: PropTypes.number,
  }).isRequired,
  isLoading: PropTypes.bool,
  justUpdated: PropTypes.bool,
};

export default CounterCards;
